"use strict";
import { getAccount } from "@wagmi/core";
import { popupRegistry } from "components/Popups/registry";
import { PopupType } from "components/Popups/types";
import { wagmiConfig } from "components/Web3Provider/wagmiConfig";
import { getSigner, watchForInterruption } from "state/sagas/transactions/utils";
import { addTransaction } from "state/transactions/reducer";
import { handleGetCapabilities } from "state/walletCapabilities/lib/handleGetCapabilities";
import { setCapabilitiesByChain } from "state/walletCapabilities/reducer";
import { call, put } from "typed-redux-saga";
import { didUserReject } from "utils/swapErrorToUserReadableMessage";
const CURRENT_SEND_CALLS_VERSION = "2.0.0";
async function sendCalls(params) {
  const { signer, batchedTxRequests, from } = params;
  const chainId = `0x${params.chainId.toString(16)}`;
  const calls = batchedTxRequests.map(({ to, data, value }) => ({ to, data, value }));
  const result = await signer.provider.send("wallet_sendCalls", [
    { version: CURRENT_SEND_CALLS_VERSION, calls, from, chainId, atomicRequired: true }
  ]);
  if (typeof result === "string") {
    return result;
  }
  return result.id;
}
export function* handleAtomicSendCalls(params) {
  const { step, info, account, ignoreInterrupt, disableOneClickSwap } = params;
  const from = account.address;
  const { batchedTxRequests } = step;
  const chainId = batchedTxRequests[0].chainId;
  try {
    const { throwIfInterrupted } = yield* watchForInterruption(ignoreInterrupt);
    const signer = yield* call(getSigner, account.address);
    const batchId = yield* call(() => sendCalls({ signer, batchedTxRequests, from, chainId }));
    const connectorId = getAccount(wagmiConfig).connector?.id;
    const batchInfo = { connectorId, batchId, chainId };
    yield* put(addTransaction({ from: account.address, info, hash: batchId, chainId, batchInfo }));
    popupRegistry.addPopup({ type: PopupType.Transaction, hash: batchId }, batchId);
    yield* call(throwIfInterrupted);
    return batchId;
  } catch (error) {
    if (error.code === 5750 || isMetaMaskNonTypicalRejection(error)) {
      const updatedCapabilities = yield* call(handleGetCapabilities);
      if (updatedCapabilities) {
        yield* put(setCapabilitiesByChain(updatedCapabilities));
      }
      disableOneClickSwap();
    }
    throw error;
  }
}
function isMetaMaskNonTypicalRejection(error) {
  return didUserReject(error) && error.code === -32603;
}
